module.exports = __webpack_public_path__ + "Lato-BoldItalic.cceb0eb0e715e69c5a67.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-BoldItalic.ttf
// module id = ../../../../../src/assets/fonts/Lato-BoldItalic.ttf
// module chunks = styles